// ═══════════════════════════════════════════════════════════
//  CONFIGURAÇÃO DE MEDITAÇÕES — edite aqui à vontade!
//  Não é necessário mexer em nenhum outro arquivo.
//
//  COMO ADICIONAR UM VÍDEO:
//  1. Abra o vídeo no YouTube
//  2. Clique em "Compartilhar" → "Incorporar"
//  3. Copie apenas o ID do vídeo da URL (a parte após /embed/ ou ?v=)
//     Exemplo: youtube.com/watch?v=dQw4w9WgXcQ → ID é "dQw4w9WgXcQ"
//  4. Cole o ID no campo `youtubeId` abaixo
//
//  CATEGORIAS DISPONÍVEIS: 'guiadas' | 'rapidas' | 'natureza' | 'frequencias'
//  Para adicionar uma nova categoria, acrescente no array CATEGORIAS abaixo.
// ═══════════════════════════════════════════════════════════

// ─── CATEGORIAS (ordem e rótulos das sub-abas) ─────────────
export const CATEGORIAS = [
  { id: 'guiadas',      label: 'Guiadas',        emoji: '🧘' },
  { id: 'rapidas',      label: 'Rápidas',         emoji: '⚡' },
  { id: 'natureza',     label: 'Natureza',        emoji: '🌿' },
  { id: 'frequencias',  label: 'Alta Frequência', emoji: '✨' },
];

// ─── MEDITAÇÕES ────────────────────────────────────────────
// Cada meditação pode ter:
//   youtubeId  → ID do vídeo no YouTube (obrigatório)
//   titulo     → nome da meditação (obrigatório)
//   descricao  → texto curto embaixo do título (opcional)
//   duracao    → duração em texto, ex: '10 min' (opcional)
//   categoria  → deve ser um dos ids acima (obrigatório)

export const meditacoes = [
  // ── Guiadas ──────────────────────────────────────────────
  // {
  //   youtubeId: 'COLE_O_ID_AQUI',
  //   titulo: 'Meditação de boas-vindas',
  //   descricao: 'Uma introdução gentil ao momento presente.',
  //   duracao: '10 min',
  //   categoria: 'guiadas',
  // },

  // ── Rápidas (<5 min) ─────────────────────────────────────
  // {
  //   youtubeId: 'COLE_O_ID_AQUI',
  //   titulo: 'Respiração 4-7-8',
  //   descricao: 'Acalme o sistema nervoso em menos de 5 minutos.',
  //   duracao: '4 min',
  //   categoria: 'rapidas',
  // },

  // ── Sons da Natureza ─────────────────────────────────────
  // {
  //   youtubeId: 'COLE_O_ID_AQUI',
  //   titulo: 'Chuva na floresta',
  //   descricao: 'Sons relaxantes para foco e sono profundo.',
  //   duracao: '1 hora',
  //   categoria: 'natureza',
  // },

  // ── Alta Frequência ──────────────────────────────────────
  // {
  //   youtubeId: 'COLE_O_ID_AQUI',
  //   titulo: '528 Hz — Frequência do amor',
  //   descricao: 'Tom de cura e transformação.',
  //   duracao: '3 horas',
  //   categoria: 'frequencias',
  // },
];
